import { FormattedMessage, FormattedPlural } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { spaceXL } from '@xing-com/tokens';

import { useSearchContext } from '../../context';
import { useLimitedSearchCount } from '../../hooks';

const StyledButton = styled(Button)`
  position: sticky;
  margin: 0 auto;
  bottom: ${spaceXL};
  display: flex;
`;

type ShowResultsButtonProps = {
  setShowBottomSheet: (show: boolean) => void;
};

export const ShowResultsButton: React.FC<ShowResultsButtonProps> = ({
  setShowBottomSheet,
}) => {
  const { count, loading } = useSearchContext();
  const total = useLimitedSearchCount();

  return (
    <>
      <StyledButton
        loading={loading}
        variant="primary"
        onClick={() => setShowBottomSheet(false)}
        data-testid="show-results-button"
      >
        <FormattedPlural
          value={count ?? 0}
          one={<FormattedMessage id="SEARCH_FILTERS_SHOW_RESULTS_BUTTON.one" />}
          other={
            <FormattedMessage
              id="SEARCH_FILTERS_SHOW_RESULTS_BUTTON.other"
              values={{
                total,
              }}
            />
          }
        />
      </StyledButton>
    </>
  );
};
